import { render, staticRenderFns } from "./PowerIcon.vue?vue&type=template&id=2f5ee2c1&scoped=true"
import script from "./PowerIcon.vue?vue&type=script&lang=js"
export * from "./PowerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ee2c1",
  null
  
)

export default component.exports